import { render, staticRenderFns } from "./widgetBarCompareChart.vue?vue&type=template&id=73a24af8&scoped=true"
import script from "./widgetBarCompareChart.vue?vue&type=script&lang=js"
export * from "./widgetBarCompareChart.vue?vue&type=script&lang=js"
import style0 from "./widgetBarCompareChart.vue?vue&type=style&index=0&id=73a24af8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a24af8",
  null
  
)

export default component.exports